__webpack_require__.p = "https://static.coretava.com/fe/dashboard/";